module.exports = __webpack_public_path__ + "img/petinder_white.84f8c79b.svg";